import React from 'react';
import { Link } from 'react-router-dom';
import personImg from '../assets/images/personImg3.png';

const WordPressMain = () => {

  const mainPageData = [
    {
      title: "Single Sign-On",
      color: "#eb5424",
      to: '/demo/wp/sso'
    },
    {
      title: "WordPress as IDP",
      color: "#5177FF",
      to: '/demo/wp/wpidp'
    },
    {
      title: "AD/LDAP Authentication",
      color: "#B153FA",
      to: '/demo/wp/ldap'
    },
    {
      title: "MFA/2FA Authentication",
      color: "#FEC400",
      to: '/demo/wp/mfa'
    },
    {
      title: "SharePoint/OneDrive Integration",
      color: "#00A5AB",
      to: '/demo/wp/sharepoint'
    },
    {
      title: "Salesforce Integration",
      color: "#FEC400",
      to: '/demo/wp/salesforce'
    },
    {
      title: "Power BI Integration",
      color: "#5177FF",
      to: '/demo/wp/powerbi'
    },
        {
      title: "MCP Server for WordPress with AI Policy Enforcement",
      color: "#B153FA",
      to: '/demo/wp/aigovern'
    },
    {
      title: "Entra ID / Azure B2C Integration",
      color: "#eb5424",
      to: '/demo/wp/entra'
    },
    {
      title: "Dynamics CRM Integration",
      color: "#FEC400",
      to: '/demo/wp/dcrm'
    },
    {
      title: "MS Outlook Integration",
      color: "#B153FA",
      to: '/demo/wp/outlook'
    },
    {
      title: "Web3 Authentication",
      color: "#5177FF",
      to: '/demo/wp/web3'
    },
    {
      title: "Web Hosting for WordPress",
      color: "#B153FA",
      to: "/demo/wp/webhosting"
    },
    {
      title: "AI Agent Studio Demo",
      color: "#eb5424",
      to: "/demo/wp/ai-agent-studio"
    },
    {
      title: "REST API Authentication",
      color: "#eb5424",
      to: '/demo/wp/restapi'
    },
    {
      title: "ProctoPress",
      color: "#00A5AB",
      to: '/demo/wp/procto'
    },
    {
      title: "Management Tool for Web Agency",
      color: "#FEC400",
      to: '/demo/wp/webagency'
    }
  ]

  return (
    <>
      <div className='w-100 py-3 px-5' style={{ height: '91vh' }}>
        <div className='mx-2 h-auto'>
          <div className='backButton d-flex align-items-center' onClick={() => window.history.back()}>
            <span class="material-symbols-rounded text-dark">
              keyboard_arrow_left
            </span>
            <p className='mb-0'>Back to main page</p>
          </div>
        </div>
        <div className='row align-items-center justify-content-center'>
          <div className='col-10'>
            <div className='row'>
              <div className='col-12  mb-3 d-flex justify-content-center align-items-center'>

                <h2 className='lh-base' style={{ color: "#555555" }}>WordPress Plugins</h2>

              </div>
              {mainPageData.map((item) => (
                <div className='col-12 col-lg-4 col-xl-3 col-sm-6 p-2'>
                  <Link className='text-decoration-none' to={item.to}>
                    <div className='border rounded px-5 py-4 mainPageItems h-100'>
                      <div className='d-flex w-100 justify-content-between align-items-center'>
                        <div style={{ width: "40px", height: "5px", background: `${item.color}` }} className="rounded"></div>
                        <span class="material-symbols-rounded text-dark">
                          east
                        </span>
                      </div>
                      <h5 className=' mt-4 my-3 text-black'>{item.title}</h5>
                      {item.text}
                    </div>
                  </Link>
                </div>
              ))}
            </div>

          </div>
        </div>

      </div>
    </>
  )
}

export default WordPressMain